const formControlLabelFormServiceQuestList = {
  YES: 'Atende',
  NO: 'Não atende',
  NA: 'Não se aplica',
  needAction: "Ações são obrigatórias para questões com resposta 'Não atende' nesse serviço",
  questionDescription: 'Descrição da pergunta'
};

export default formControlLabelFormServiceQuestList;
